<template>
  <div class="earnings">
    <div style="padding: 0px 20px;height: 100%">
      <div class="search">
        <div class="search_box">
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[0].title}}</span>
            <el-select class="select" v-model="selectProjectValue" placeholder="请选择项目" @change="getSelectTeam(selectProjectValue )">
              <el-option v-for="item in search[0].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[1].title}}</span>
            <el-select class="select" v-model="selectTeamValue" placeholder="请选择群组" @change="getSelectWork(selectTeamValue )">
              <el-option v-for="item in search[1].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div  class="search_options_box">
            <span style="width: 100px;">{{search[2].title}}</span>
            <el-select class="select" v-model="selectWorkValue" placeholder="请选择小组" >
              <el-option v-for="item in search[2].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </div>
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]'><span class="el-icon-search"></span>搜索</button>
          </div>
        </div>
      </div>


      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(33% - 13px)'},{'min-height':'522px'},{height:'37.5%'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button class="income_btn focus">金额/时间分布</button>
          </div>
          <div id="money"></div>
        </div>
      </div>
      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(33% - 13px)'},{'min-height':'522px'},{height:'37.5%'},{marginLeft:'20px'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button class="income_btn focus">时段分布图</button>
          </div>
          <div id="time"></div>
        </div>
      </div>
      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(33% - 13px)'},{'min-height':'522px'},{height:'37.5%'},{marginLeft:'20px'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn" style="position: relative">
            <button class="income_btn focus">广告投放效果</button>
            <h1 style="position: absolute;bottom: -36px;font-size:14px;color: #FFFFFF">浏览量（PV）/点击量（CV）</h1>
          </div>
          <div id="ad"></div>
        </div>
      </div>


      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(100% - 10px)'},{'min-height':'300px'},{height:'37.5%'},{marginBottom:'20px'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button class="income_btn focus">实时用户信息</button>
            <div class="export_btn_box">
              <button @click="export2Excel()" :class='["export_btn","green","icon_btn","clearborder"]'><span
                class="icon-9"></span>导出数据
              </button>
            </div>
          </div>
          <div id="user">
            <table>
              <thead>
              <tr>
                <th>用户名</th>
                <th>上线时间</th>
                <th>下线时间</th>
                <th>上线地点（灯杆位置）</th>
                <th>手机类型</th>
                <th>浏览器类型</th>
                <th>操作系统类型</th>
                <th>上线时长（分钟）</th>
                <th>使用流量（MB）</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in table_data">
                <td>{{item.user}}</td>
                <td>{{item.online_time}}</td>
                <td>{{item.offline_time}}</td>
                <td>{{item.site}}</td>
                <td>{{item.phone_type}}</td>
                <td>{{item.web_type}}</td>
                <td>{{item.system}}</td>
                <td>{{item.time}}</td>
                <td>{{item.flow}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  //引入echarts
  let echarts = require('echarts/lib/echarts');
  // 引入柱状图组件
  require('echarts/lib/chart/bar');
  require('echarts/lib/chart/line');
  require('echarts/lib/chart/scatter');
  require('echarts/lib/chart/effectScatter');
  require('echarts/lib/chart/heatmap');
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/title');
  require('echarts/lib/component/legend');
  require('echarts/lib/component/geo');
  export default {
    name: "earnings",
    data() {
      return {
        search: [
          {
            title: '选择项目',
            options: [],
          }, {
            title: '选择群组',
            options: [],
          }, {
            title: '选择小组',
            options: [],
          },
        ],
        projectList:[],
        teamList:[],
        workList:[],
        selectProjectValue:'',
        selectTeamValue:'',
        selectWorkValue:'',

        table_data: [
          {
            user: "157***78",
            online_time: "2019-10-31 16:26",
            offline_time: "2019-10-31 16:49",
            site: "安平县吉祥公园",
            phone_type: "iPhone",
            web_type: "Safari浏览器",
            system: "iOS",
            time: "23",
            flow: "198"
          },
          {
            user: "135***59",
            online_time: "2019-10-31 15:44",
            offline_time: "2019-10-31 16:30",
            site: "安平县为民街道",
            phone_type: "小米",
            web_type: "百度浏览器",
            system: "安卓",
            time: "46",
            flow: "357"
          },
          {
            user: "180***47",
            online_time: "2019-10-31 14:27",
            offline_time: "2019-10-31 14:45",
            site: "安平县吉祥公园",
            phone_type: "华为",
            web_type: "QQ浏览器",
            system: "安卓",
            time: "18",
            flow: "125"
          },
          {
            user: "156***53",
            online_time: "2019-10-31 13:17",
            offline_time: "2019-10-31 13:45",
            site: "安平县汉王酒店",
            phone_type: "OPPO",
            web_type: "QQ浏览器",
            system: "安卓",
            time: "28",
            flow: "190"
          },
          {
            user: "132***01",
            online_time: "2019-10-31 12:27",
            offline_time: "2019-10-31 12:50",
            site: "安平县为民街道",
            phone_type: "华为",
            web_type: "QQ浏览器",
            system: "安卓",
            time: "23",
            flow: "174"
          },
          {
            user: "151***19",
            online_time: "2019-10-31 12:13",
            offline_time: "2019-10-31 12:56",
            site: "安平县汉王酒店",
            phone_type: "华为",
            web_type: "百度浏览器",
            system: "安卓",
            time: "43",
            flow: "325"
          },
          {
            user: "177***32",
            online_time: "2019-10-31 12:05",
            offline_time: "2019-10-31 12:57",
            site: "安平县吉祥公园",
            phone_type: "OPPO",
            web_type: "百度浏览器",
            system: "安卓",
            time: "52",
            flow: "426"
          },
          {
            user: "158***06",
            online_time: "2019-10-31 11:48",
            offline_time: "2019-10-31 12:03",
            site: "安平县为民街道",
            phone_type: "小米",
            web_type: "QQ浏览器",
            system: "安卓",
            time: "15",
            flow: "133"
          },
          {
            user: "137***56",
            online_time: "2019-10-31 11:25",
            offline_time: "2019-10-31 11:33",
            site: "安平县吉祥公园",
            phone_type: "小米",
            web_type: "百度浏览器",
            system: "安卓",
            time: "8",
            flow: "74"
          },
          {
            user: "155***88",
            online_time: "2019-10-31 11:17",
            offline_time: "2019-10-31 11:35",
            site: "安平县汉王酒店",
            phone_type: "iPhone",
            web_type: "Safari浏览器",
            system: "iOS",
            time: "18",
            flow: "196"
          },
          {
            user: "132***59",
            online_time: "2019-10-31 11:03",
            offline_time: "2019-10-31 11:35",
            site: "安平县为民街道",
            phone_type: "华为",
            web_type: "百度浏览器",
            system: "安卓",
            time: "32",
            flow: "311"
          },
          {
            user: "131***08",
            online_time: "2019-10-31 10:25",
            offline_time: "2019-10-31 09:51",
            site: "安平县吉祥公园",
            phone_type: "iPhone",
            web_type: "Safari浏览器",
            system: "iOS",
            time: "26",
            flow: "269"
          },
          {
            user: "151***03",
            online_time: "2019-10-31 09:39",
            offline_time: "2019-10-31 09:53",
            site: "安平县为民街道",
            phone_type: "三星",
            web_type: "QQ浏览器",
            system: "安卓",
            time: "14",
            flow: "102"
          },
          {
            user: "177***81",
            online_time: "2019-10-31 09:31",
            offline_time: "2019-10-31 09:51",
            site: "安平县为民街道",
            phone_type: "华为",
            web_type: "QQ浏览器",
            system: "安卓",
            time: "20",
            flow: "264"
          },
          {
            user: "158***02",
            online_time: "2019-10-31 09:18",
            offline_time: "2019-10-31 09:43",
            site: "安平县汉王酒店",
            phone_type: "小米",
            web_type: "QQ浏览器",
            system: "安卓",
            time: "25",
            flow: "223"
          },
          {
            user: "152***89",
            online_time: "2019-10-31 08:27",
            offline_time: "2019-10-31 08:42",
            site: "安平县为民街道",
            phone_type: "魅族",
            web_type: "UC浏览器",
            system: "安卓",
            time: "15",
            flow: "124"
          },
        ]
      }
    },
    methods: {
      InitLeftMenu: function () {
        this.$emit('getMessage', '3', '1');
      },
      export2Excel() {
        var that = this;
        require.ensure([], () => {
          const {export_json_to_excel} = require('@/excel/export2excel'); //这里必须使用绝对路径，使用@/+存放export2Excel的路径
          const tHeader = ['用户名', '上线时间', '下线时间', '上线地点（灯杆位置）', '手机类型', '浏览器类型', '操作系统类型', '上线时间（分钟）', '使用浏览（MB）']; // 导出的表头名信息
          const filterVal = ['user', 'online_time', 'offline_time', 'site', 'phone_type', 'web_type', 'system', 'time', 'flow']; // 导出的表头字段名，需要导出表格字段名
          const list = that.table_data;
          const data = that.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, '实时用户信息');// 导出的表格名称，根据需要自己命名
        })
      },
      //格式转换，直接复制即可
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
      init: function () {
        let times = [
          [1563120000000, 2],
          [1563724800000, 6],
          [1564329600000, 3],
          [1564934400000, 9],
          [1565539200000, 8],
          [1566144000000, 6],
          [1563276156000, 8],
          [1563322956000, 11],
          [1563517356000, 9],
          [1563603756000, 7],
          [1564313127000, 8],
          [1564154556000, 4],
          [1563981756000, 2],
          [1564399527000, 12],
          [1564572327000, 6],
          [1563276156000, 4],
          [1564716327000, 11],
          [1564889127000, 2],
          [1565148327000, 7],
          [1565753127000, 11],
          [1565925927000, 2],
          [1566012327000, 7],
        ];
        let myChart1 = echarts.init(document.getElementById('money'));
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
          },
          grid: {
            left: '5%',
            top: "8%",
            right: '5%',
            bottom: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'time',
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#244465 '
              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          },
          yAxis: {
            name: "收入总额(万元)",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#244465 '
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          },
          series: [{
            name: '收入总额',
            type: 'effectScatter',
            symbolSize: 10,
            showSymbol: false,
            hoverAnimation: false,
            color: "#00effe",
            data: times
          }]
        });


        let hours = ['8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00',
          '15:00', '16:00', '17:00', '18:00', '19:00',
          '20:00'];
        let days = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];

        let data = [
          [0, 0, 0], [0, 1, 113], [0, 2, 212], [0, 3, 110], [0, 4, 423], [0, 5, 81], [0, 6, 6], [0, 7, 0], [0, 8, 120], [0, 9, 130], [0, 10, 428], [0, 11, 612], [0, 12, 944],
          [1, 0, 14], [1, 1, 141], [1, 2, 121], [1, 3, 223], [1, 4, 465], [1, 5, 75], [1, 6, 134], [1, 7, 201], [1, 8, 241], [1, 9, 124], [1, 10, 514], [1, 11, 141], [1, 12, 1010],
          [2, 0, 112], [2, 1, 0], [2, 2, 451], [2, 3, 0], [2, 4, 651], [2, 5, 311], [2, 6, 141], [2, 7, 410], [2, 8, 941], [2, 9, 410], [2, 10, 143], [2, 11, 320], [2, 12,1121],
          [3, 0, 20], [3, 1, 341], [3, 2, 0], [3, 3, 413], [3, 4, 215], [3, 5, 58], [3, 6, 134], [3, 7, 0], [3, 8, 114], [3, 9, 741], [3, 10, 255], [3, 11, 414], [3, 12, 864],
          [4, 0, 0], [4, 1, 81], [4, 2, 151], [4, 3, 0], [4, 4, 481], [4, 5, 123], [4, 6, 124], [4, 7, 495], [4, 8, 414], [4, 9, 211], [4, 10, 411], [4, 11, 814], [4, 12, 985],
          [5, 0, 13], [5, 1, 0], [5, 2, 332], [5, 3, 425], [5, 4, 456], [5, 5, 623], [5, 6, 511], [5, 7, 374], [5, 8, 349], [5, 9, 495], [5, 10, 544], [5, 11, 645], [5, 12, 1215],
          [6, 0, 0], [6, 1, 76], [6, 2, 146], [6, 3, 442], [6, 4, 634], [6, 5, 941], [6, 6, 741], [6, 7, 556], [6, 8, 231], [6, 9, 498], [6, 10, 648], [6, 11, 801], [6, 12, 1536],
        ];

        data = data.map(function (item) {
          return [item[1], item[0], item[2] || '-'];
        });
        let myChart2 = echarts.init(document.getElementById('time'));
        myChart2.setOption({
          tooltip: {
            position: 'top'
          },
          animation: false,
          grid: {
            left: '2%',
            right: '5%',
            bottom: '10%',
            top: "8%",
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: hours,
            splitArea: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#244465 '
              }
            },
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff"
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          },
          yAxis: {
            name: "周期(天)",
            type: 'category',
            data: days,
            splitArea: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#244465 '
              }
            },
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#ffffff"
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          },
          visualMap: {
            min: 0,
            max: 1000,
            calculable: true,
            show: false,
            orient: 'horizontal',
            left: 'center',
            bottom: '15%'
          },
          series: [{
            name: '上线人数',
            type: 'heatmap',
            data: data,
            label: {
              normal: {
                show: true
              }
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        });


        let dataMap = {};

        function dataFormatter(obj) {
          var pList = ['广告1', '广告2', '广告3', '广告4', '广告5', '广告6'];
          var temp;
          for (var month = 1; month <= 8; month++) {

            temp = obj[month.toString()];
            obj[month + 'sum'] = temp[0];
            for (var i = 1, len = temp.length; i < len; i++) {
              obj[month.toString()][i] = {
                name: pList[i],
                value: temp[i]
              }
            }
            obj[month.toString()].shift()
          }
          return obj;
        }

        dataMap.dataMonth = dataFormatter({
          //max : 60000,
          '1': [1020, 2415, 4415, 3425, 4354, 4434, 4344,],
          '1-1': [415, 1415, 1255, 1425, 1244, 1434,],
          '2': [928, 1239, 4215, 3257, 2835, 7514, 4124,],
          '2-2': [928, 1239, 2215, 2257, 2835, 2514],
          '3': [1024, 4279, 2625, 3127, 5252, 3644, 5244],
          '3-3': [1024, 1269, 2625, 3127, 1252, 2644],
          '4': [1024, 4769, 2625, 7127, 6252, 6644, 6244],
          '4-4': [1024, 1769, 5625, 3127, 5252, 3644],
          '5': [1024, 4169, 3625, 5127, 5252, 3644, 4244],
          '5-5': [1024, 1769, 2625, 3127, 1252, 1644],
          '6': [1024, 4619, 2625, 3127, 5252, 5644, 8244],
          '6-6': [1024, 1769, 2625, 3127, 3252, 6644],
          '7': [1024, 4279, 4625, 4127, 5252, 6644, 5244],
          '7-7': [1024, 2119, 2625, 3127, 3252, 3644],
          '8': [1024, 4769, 2625, 3127, 5252, 3644, 5244],
          '8-8': [1024, 2169, 2625, 3127, 1252, 2644],
        });

        let myChart3 = echarts.init(document.getElementById('ad'));
        myChart3.setOption({
          baseOption: {
            timeline: {
              axisType: 'time',
              autoPlay: true,
              inverse: true,
              left: '10%',
              right: '10%',
              width: '80%',
              bottom: -15,
              playInterval: 2500,
              controlStyle: {
                show: true,
                showPlayBtn: false,
                showPrevBtn: true,
                showNextBtn: true,
                color: "#ffffff",
                borderColor: "#ffffff",
                borderWidth: 1,
              },
              lineStyle: {
                color: "#ffffff"
              },
              label: {
                normal: {
                  show: false,
                  textStyle: {
                    color: '#fff'
                  }
                },
                emphasis: {
                  textStyle: {
                    color: '#ffffff'
                  }
                }
              },
              itemStyle: {
                color: "#ffffff"
              },
              symbol: 'circle',
              checkpointStyle: {
                color: '#21b868',
                borderColor: 'rgba(33,184,104,0.5)',
                borderWidth: 5
              },
              data: [1565539200000, 1566119297000, 1566032897000, 1565946497000, 1565860097000, 1565773697000, 1565687297000, 1565600897000],
            },
            tooltip: {
              position: 'top',
              trigger: 'axis',
              axisPointer: {
                type: "shadow"
              }
            },
            legend: {
              right: 0,
              textStyle: {
                color: '#ffffff',
              }
            },
            calculable: true,
            grid: {
              left: '5%',
              right: '5%',
              bottom: '8%',
              top: "8%",
              containLabel: true
            },
            xAxis: [{
              name: "",
              type: 'category',
              axisLabel: {
                interval: 0,
                textStyle: {
                  color: "#ffffff"
                },
              },
              data: ['广告1', '广告2', '广告3', '广告4', '广告5', '广告6'],
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dashed',
                  color: '#244465 '
                }
              },
              nameTextStyle: {
                color: "#ffffff",
                fontSize: 14,
                align: "left",
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#244465",
                }
              }
            }],
            yAxis: [{
              type: 'value',
              splitArea: {
                show: false
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dashed',
                  color: '#244465 '
                }
              },
              nameTextStyle: {
                color: "#ffffff",
                fontSize: 14,
                align: "left",
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#ffffff"
                },
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#244465",
                }
              }
            }],
            series: [
              {
                name: '浏览量',
                type: 'bar',
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#01c8b3' // 0% 处的颜色
                    }, {
                      offset: 1,
                      color: '#67ffcb' // 100% 处的颜色
                    }], false),
                    barBorderRadius: [5, 5, 0, 0],
                  }
                },
              }, {
                name: '点击量',
                type: 'bar',
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#48aaff' // 0% 处的颜色
                    }, {
                      offset: 1,
                      color: '#68f3ff' // 100% 处的颜色
                    }], false),
                    barBorderRadius: [5, 5, 0, 0],
                  }
                },
              },
            ]
          },
          options: [{
            series: [{
              data: dataMap.dataMonth['1'],
            }, {
              data: dataMap.dataMonth['1-1'],
            }]
          },
            {
              series: [{
                data: dataMap.dataMonth['2'],

              }, {
                data: dataMap.dataMonth['2-2'],
              }]
            },
            {
              series: [{
                data: dataMap.dataMonth['3'],
              }, {
                data: dataMap.dataMonth['3-3'],
              }]
            }, {
              series: [{
                data: dataMap.dataMonth['4'],
              }, {
                data: dataMap.dataMonth['4-4'],
              }]
            },
            {
              series: [{
                data: dataMap.dataMonth['5'],

              }, {
                data: dataMap.dataMonth['5-5'],
              }]
            },
            {
              series: [{
                data: dataMap.dataMonth['6'],
              }, {
                data: dataMap.dataMonth['6-6'],
              }]
            }, {
              series: [{
                data: dataMap.dataMonth['7'],
              }, {
                data: dataMap.dataMonth['7-7'],
              }]
            },
            {
              series: [{
                data: dataMap.dataMonth['8'],

              }, {
                data: dataMap.dataMonth['8-8'],
              }]
            },
          ]
        });

        window.onresize = function () {
          myChart1.resize();
          myChart2.resize();
          myChart3.resize();
        };
      },


      //获取小组列表
      getSelectWork:function(id){
        fetch("/api/v1/controller/list", {
          method: 'post',
          body: JSON.stringify({
            "groups_id":id,
            "page_size":10,
            "page_start":0,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "小组数据获取成功";
              this.search[2].options=[];
              this.workList = data.data;
              let options = this.search[2].options;
              for (let i=0;i<this.workList.length;i++){
                let projectObj = {};
                projectObj.label = this.workList[i].name;
                projectObj.value = this.workList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },



      //获取群组列表
      getSelectTeam:function(id){
        fetch("/api/v1/groups/list", {
          method: 'post',
          body: JSON.stringify({
            "project_id":id,
            "page_size":10,
            "page_start":0,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "群组数据获取成功";
              this.search[1].options=[];
              this.search[2].options=[];
              this.teamList = data.data;
              let options = this.search[1].options;
              for (let i=0;i<this.teamList.length;i++){
                let projectObj = {};
                projectObj.label = this.teamList[i].name;
                projectObj.value = this.teamList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      //获取项目列表
      getProjectList:function(){
        fetch("/api/v1/project/list", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "项目数据获取成功";
              this.projectList = data.data;
              let options = this.search[0].options;
              for (let i=0;i<this.projectList.length;i++){
                let projectObj = {};
                projectObj.label = this.projectList[i].name;
                projectObj.value = this.projectList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


    },
    created() {
      this.InitLeftMenu();
      this.getProjectList();
    },
    mounted() {
      this.init();
    }
  }
</script>

<style scoped>
  .earnings {
    width: 100%;
    height: 100%;
  }

  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .search_options_box {
    width: 20%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .nva_btn {
    padding: 20px;
  }

  .income_btn {
    background: transparent;
    font-size: 16px;
    border: transparent;
    outline: transparent;
    color: #95bee5;
    margin-right: 20px;
  }

  .focus {
    font-size: 18px;
    color: #00f0ff;
  }

  .export_btn_box {
    width: 110px;
    float: right;
  }

  .export_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    box-shadow: 0px 3px 0px #18884d;
  }

  #user, #money, #ad, #time {
    height: calc(100% - 67px);
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    overflow-y: auto;
  }

  #user {
    padding: 0 20px;
    box-sizing: border-box;
  }

  #user table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
  }

  #user table thead tr {
    height: 40px;
    border-bottom: 1px solid #094b8e;
  }

  #user table thead tr th {
    color: #FFFFFF;
    font-size: 16px;
  }

  #user table tbody {
    display: block;
    height: 100%;
    overflow-y: scroll;
  }

  #user table thead tr,
  #user table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    text-align: center;
  }

  #user table tbody tr {
    background: #16518d;
    border-bottom: 1px solid #094b8e;
  }

  #user table tbody tr:nth-child(2n+0) {
    background: #11406f;
  }

  #user table tbody tr td {
    height: 40px;
    color: #FFFFFF;
  }


  #user thead th,
  #user tbody td {
    width: 40px;
  }

  #user table thead {
    width: calc(100% - 1em);
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/4_wifi/earnings.vue